import React, { useContext, useEffect, useState } from 'react'
import { PlusCircle } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom'
import { CurrentProjectManagerContext } from '../../../contexts/CurrentProjectManagerContext'
import axiosService from '../../../utils/AxiosService'
import ProjectManagerItem from './ProjectManagersPart/ProjectManagerItem';

export default function ProjectManagers() {
  const { currentProjectManager } = useContext(CurrentProjectManagerContext)
  const navigate = useNavigate()
  const [projectManagers, setProjectManagers] = useState([])

  useEffect(() => {
    if(!currentProjectManager?.id) return
    if(!currentProjectManager.is_admin) navigate('/project_manager/campaigns')

    getProjectManagers()
  },[currentProjectManager?.id])

  const getProjectManagers = () => {
    axiosService.get('/api/project_manager/project_managers')
    .then(project_managers => setProjectManagers(project_managers))
    .catch(resp => console.log(resp))
  }


  return (
    <div className="pt-12 bg-white dark:bg-rb-dark-mode min-h-screen">
      <div className="flex items-center justify-between w-full h-20 px-24 align-center bg-gradient-to-br from-rb-green from-30% via-teal-500 via-60% to-rb-green to-90%">
        <p className="text-white text-2xl">
          Project Manager Dashboard
        </p>
        <button
          className="flex items-center text-rb-green bg-white px-2 h-10 rounded-full active:shadow-outer active:shadow-teal-200 dark:bg-rb-dark-mode-lighter dark:text-white"
          onClick={() => navigate('/project_manager/project-managers/new')}
        >
          <PlusCircle />
          <p className="ml-3">
            New
          </p>
        </button>
      </div>
      <div className="px-24 pt-8">
        <table className="table-auto w-full text-center bg-rb-green rounded-md dark:bg-rb-green">
          <thead className="">
            <tr>
              <th className="w-40 p-4 text-white border-r-2 dark:border-rb-dark-mode-lighter">Id</th>
              <th className="w-40 p-4 text-white border-r-2 dark:border-rb-dark-mode-lighter">Email</th>
              <th className="w-40 p-4 text-white border-r-2 dark:border-rb-dark-mode-lighter">Admin</th>
              <th className="w-40 p-4 text-white">Options</th>
            </tr>
          </thead>
          <tbody>
            {projectManagers.map(projectManager => <ProjectManagerItem key={projectManager.id} projectManager={projectManager} getProjectManagers={getProjectManagers} />)}
          </tbody>
        </table>
      </div>
    </div>
  )
}